import ModalHandler from './ModalHandler.component'

export default ModalHandler
